//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import Constants from '../../constants';
import ModalActions from '../../Actions/modal';
import EmailForm from '../../Homepage/components/EmailForm.react';
import CookiesData from '../../Utils/cookies-data';
import NotificationsActions from '../../Actions/notifications';

function _submit(email:string) {
  CookiesData.set('email', { email });
  NotificationsActions.addNotification(Constants.PROMO_NOTIFICATION, { code: 'SNACKS50', discount: '50%' });
  ModalActions.closeModal(Constants.PROMO_EMAIL_CAPTURE_MODAL);
}

function _openLoginModal() {
  ModalActions.closeModal(Constants.PROMO_EMAIL_CAPTURE_MODAL);
  ModalActions.openModal(Constants.LOGIN_MODAL);
}

function PromoEmailCaptureModal() {
  return (
    <div>
      <div className="blueberries"></div>
      <h1>Get 50% off</h1>
      <div className="text-3 promo-offer">
        Try our delicious snacks for free. Simply unlock this offer and be the first to hear
        about new snacks and special offers like this one.
      </div>
      <EmailForm
        list="mem_promo_unlock"
        onSubmit={_submit}
        placeholder="Email"
        text="Get promo code"
      />
      <p className="sign-in">
        Already a member? <a className="link sign-in-link" onClick={_openLoginModal}>Sign In</a>
      </p>
    </div>
  );
}

export default modal<{}>(PromoEmailCaptureModal, {
  name: Constants.PROMO_EMAIL_CAPTURE_MODAL,
  className: 'promo-email-capture-modal',
});
